import { MacBookWindow } from '@rumblefish/ui/Rumblefish23Theme';
import { scrollToElement } from '../../../utils/handleScroll';
import { syntheticDataGenerationContactFormId } from '../syntheticDataGenerationPage.consts';
import { syntheticDataHeroData } from './Hero.data';

export const Hero = () => {
  return (
    <>
      <MacBookWindow
        title={syntheticDataHeroData.title}
        description={syntheticDataHeroData.description}
        buttonText="Let's talk about your project"
        buttonLink="/contact"
        buttonHandleOnClick={() =>
          scrollToElement(syntheticDataGenerationContactFormId)
        }
        gradient="aqua"
      />
    </>
  );
};
